export default __webpack_public_path__ + "img/brTQciJy.6f7fa583.svg";